/* RESPONSIBLE TEAM: team-workflows */
import Controller from '@ember/controller';

export default class WorkflowsTroubleshootConversationsWithIdEventsEventController extends Controller {
  queryParams = ['eventTypes', 'status'];
}
